import React from 'react';
import { SignatureSongLyrics } from './SignatureSongLyrics';

export const SignatureSongContentDe: React.FC = () => (
  <>
    <h2>„I Think It's You" – unsere Hymne auf den verpassten Moment und die zweite Chance</h2>
    <p>
      Manche Begegnungen dauern nur Sekunden – und bleiben doch lange im Kopf.
    </p>
    <p>
      Genau davon erzählt <strong>„I Think It's You"</strong>: von diesem einen Blick, diesem kurzen Knistern, diesem geheimnisvollen Gefühl, dass da vielleicht mehr war. Unser Signature Song bringt musikalisch auf den Punkt, worum es bei <strong>Missed Connections</strong> geht: um Anziehung, um Mut im zweiten Anlauf und um die schöne Möglichkeit, einen besonderen Moment doch nicht einfach vorbeiziehen zu lassen.
    </p>
    <p>
      Der Song ist dabei bewusst ein wenig <strong>geheimnisvoll, anonym und top secret</strong> – wie eine verschlüsselte Botschaft zwischen zwei Menschen, die sich gesehen, aber noch nicht gefunden haben. Er ist Soundtrack und Signal zugleich: eine elegante Brücke zwischen flüchtiger Begegnung und späterem Wiedersehen.
    </p>
    <p>
      Gerade bei unseren <strong>Events und Single-Veranstaltungen im Crime Club</strong> entfaltet <strong>„I Think It's You"</strong> seine besondere Kraft. Denn nicht immer will oder kann man sich sofort ansprechen. Manchmal braucht es erst den richtigen Moment danach. Genau dann wird der Song zur Hymne für alle, die sich sympathisch waren, sich gegenseitig bemerkt haben – und sich im Nachhinein vielleicht doch noch kennenlernen möchten.
    </p>
    <p>
      <strong>„I Think It's You"</strong> ist mehr als ein Song.<br />
      Er ist ein Gefühl. Ein Code. Eine zweite Chance in Musikform.
    </p>

    <SignatureSongLyrics
      listenCaption={'\u201EI Think It\u2019s You\u201C \u2013 anh\u00F6ren'}
      audioUnsupportedFallback="Dein Browser unterstützt keine eingebettete Audio-Wiedergabe."
    />
  </>
);
